module.exports = __webpack_public_path__ + "static/img/Eels.948e0bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Eels.svg
// module id = ojeU
// module chunks = 1